// extracted by mini-css-extract-plugin
export default {"form":"SAO9ahfrVcmyIxgAPzAE__form___","footer":"VnYquAMId1Nua1zL1lHQ__footer___"};